import type { GlucoseCoefficientOfVariationInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import styles from "./Tile.module.scss"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { round } from "src/utils"

export function GlucoseCoefficientOfVariation(props: TileProps<GlucoseCoefficientOfVariationInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()
  const { glucoseCalculations } = useCalculationsContext()
  const { coefficientOfVariation } = glucoseCalculations[range] || {}

  const value = isNaN(coefficientOfVariation) || coefficientOfVariation === undefined
    ? "--"
    : round(coefficientOfVariation)

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {value.toLocaleString(polyglot.locale())}
        <span
          className={styles.valuePercentSymbol}
          id={`${insightKey}-percent`}
        >
          %
        </span>
      </TileValue>
    </>
  )
}
